import React, { type CSSProperties, type ForwardedRef } from 'react';
import { useController } from '@aha-app/mvc';
import AlignmentUtils from '../../AlignmentPlugin/AlignmentUtils';
import classNames from 'classnames';
import BlockUtils from '../BlockUtils';
import './Block.css';
import styles from './Block.module.css';
import AnchorLinkIcon from './AnchorLinkIcon';
import AhaEditorV2Controller from '../../../controllers/AhaEditorV2Controller';

interface BlockProps {
  tag: string;
  attributes?: any;
  dataAttrs?: Record<string, string | undefined>;
  style?: CSSProperties;
  className?: string;
  hasAnchor?: boolean;
  element: any;
  children: React.ReactNode;
}

const Block = (props: BlockProps, ref: ForwardedRef<HTMLElement>) => {
  const extraAttributes: Record<string, string | undefined> = {};
  const style = props.style ?? {};
  const className = props.className ?? '';
  const controller = useController(AhaEditorV2Controller);

  const alignmentClass = AlignmentUtils.alignmentClassForValue(
    props.element.alignment
  );

  if (props.element.lineHeight) {
    style.lineHeight = props.element.lineHeight;
  }

  extraAttributes.id = BlockUtils.blockAnchorId(props.element);
  let anchorLink: React.ReactNode | null = null;

  const documentURL = controller?.state?.pluginState?.anchorBaseURL;
  if (documentURL !== undefined && extraAttributes.id) {
    anchorLink = (
      <AnchorLinkIcon href={`${documentURL}#${extraAttributes.id}`} />
    );
  }

  const dataAttrs = Object.entries(props.dataAttrs ?? {});
  for (const [key, value] of dataAttrs) {
    extraAttributes[`data-${key}`] = value;
  }

  return (
    <props.tag
      className={classNames(className, alignmentClass, {
        [styles.anchorCopyLinkContainer]: !!anchorLink,
      })}
      ref={ref}
      {...props.attributes}
      {...extraAttributes}
      style={style}
    >
      {props.children}
      {anchorLink}
    </props.tag>
  );
};

export default React.forwardRef(Block);
